import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css'; // Assuming you might want to add specific styles for the footer

const Footer = () => {
    return (
        <footer className="bg-dark text-white py-4">
            <Container>
                <Row>
                    <Col className="text-center">
                        <p>&copy; {new Date().getFullYear()} Pluracore All rights reserved.</p>
                        <div>
                            <a href="https://facebook.com" className="text-white me-3">Facebook</a>
                            <a href="https://twitter.com" className="text-white me-3">Twitter</a>
                            <a href="https://instagram.com" className="text-white">Instagram</a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;